export enum TicketFolder {
    notArchived = 0, // 1 all // outdated

    open = 1, // 2 open // outdated

    pending = 11, // 3 pending // outdated

    closed = 4, // 4 completed // outdated

    expired = 3, // 5 expired

    sharedAccess = 2, // 6 assigned = forwarded

    spam = 6, // 7 spam

    draft = 7,

    assignedToMe = 8,

    // AssignedToMe = 9,

    answeredByMe = 10,

    allTickets = 12, // outdated

    closedByAgent = 13,

    closedByGroup = 14,

    reminders = 15,
}
